const ShimmerUI = () => {
  return (
    <div className="shimmerContainer">
      <div className="shimmerCard animate-slidein opacity-0 [--slidein-delay:500ms]"></div>
      <div className="shimmerCard animate-slidein opacity-0 [--slidein-delay:500ms]"></div>
      <div className="shimmerCard animate-slidein opacity-0 [--slidein-delay:500ms]"></div>
      <div className="shimmerCard animate-slidein opacity-0 [--slidein-delay:500ms]"></div>
      <div className="shimmerCard animate-slidein opacity-0 [--slidein-delay:500ms]"></div>
      <div className="shimmerCard animate-slidein opacity-0 [--slidein-delay:500ms]"></div>
      <div className="shimmerCard animate-slidein opacity-0 [--slidein-delay:500ms]"></div>
      <div className="shimmerCard animate-slidein opacity-0 [--slidein-delay:500ms]"></div>
    </div>
  );
};

export default ShimmerUI;
